
import { mapMutations } from 'vuex';
import Link from '@/components/ui/link.vue';

export default {
  name: 'Cta',

  components: { Link },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    buttonColor: {
      type: String,
      default: undefined,
    },
    textColor: {
      type: String,
      default: undefined,
    },
  },

  methods: {
    ...mapMutations(['toggleContactForm', 'closeContactForm']),
  },
};
